
import {defineComponent} from 'vue';
import Checkbox from 'primevue/checkbox';

export default defineComponent({
  name: "BooleanPicker",
  components: {Checkbox},
  data() {
    return {
      selected: this.value
    }
  },
  props: {
    name: {type: String, required: true},
    value: {type: Boolean, default: false},
  },
  watch: {
    selected() {
      this.$emit('select', {key: this.name, value: this.selected})
    }
  },
})
